import { Checkbox, FormControl, FormErrorMessage, FormLabel, Link } from "@chakra-ui/react";
import { forwardRef, ReactNode, SyntheticEvent, useImperativeHandle, useState } from "react";
import RequiredMark from "./RequiredMark";

interface InputCheckboxDateProps {
    label?: string;
    text: string,
    value?: Date;
    input?: ReactNode;
    isRequired: boolean;
    initValue?: Date;
}

const InputCheckboxDate = forwardRef((props: InputCheckboxDateProps, ref) => {

    const [value, setValue] = useState<Date | undefined>(props.initValue);
    const [textError, setTextError] = useState<string>("");

    const validateValue = () => {
        if (props.isRequired && !value) {
            setTextError(`${props.label ?? "To pole"} jest wymagane`);
            return false;
        } else {
            setTextError("");
            return true;
        }
    };

    useImperativeHandle(ref, () => ({
        validate: () => validateValue(),
        value() { return value; }
    }));

    const handleSubmit = (e: SyntheticEvent) => {
        const input = e.currentTarget as HTMLInputElement;
        if(input.checked) {
            setValue(new Date());
        } else {
            setValue(undefined);
        }
    };
  
    return (
        <FormControl isInvalid={!!textError}
            mt="5"
        >
            <FormLabel>{props.label} {props.isRequired && <RequiredMark />}</FormLabel>
                <Checkbox
                    type="text"
                    checked={value != undefined}
                    onChange={(e) => handleSubmit(e)}
                    onBlur={validateValue}
                >
                <div className="content" dangerouslySetInnerHTML={{__html: props.text != undefined ? props.text : "" }}></div>
                    </Checkbox>
                
                
            <FormErrorMessage>{textError}</FormErrorMessage>
        </FormControl>
    );
  });

  export default InputCheckboxDate;